import React, { useRef, useState, useEffect } from "react";
import PropTypes from "prop-types";
import "./video_player.css";
import { Icon } from "../Icon/Icon";
import { Text } from "../Text/Text";

const VideoPlayer = ({ src, width = "100%", height = "100%" }) => {
    const videoRef = useRef(null);
    const containerRef = useRef(null);
    const [isPlaying, setIsPlaying] = useState(false);
    const [currentTime, setCurrentTime] = useState(0);
    const [duration, setDuration] = useState(0);
    const [playbackRate, setPlaybackRate] = useState(1);
    const speedOptions = [0.5, 1, 1.5, 2];
    const [hideCover, setHideCover] = useState(false);
    const [isFullScreen, setFullScreen] = useState(false);
    const [isEnded,setEnded] = useState(false);

    const handlePlayPause = () => {
        if (isPlaying) {
            videoRef.current.pause();
        } else {
            videoRef.current.play();
        }
        setIsPlaying(!isPlaying);
    };

    const handleForward = () => {
        videoRef.current.currentTime = Math.min(
            videoRef.current.currentTime + 5,
            duration
        );
    };

    const handleBackward = () => {
        videoRef.current.currentTime = Math.max(
            videoRef.current.currentTime - 5,
            0
        );
    };

    const toggleSpeed = () => {
        const currentIndex = speedOptions.indexOf(playbackRate);
        const nextIndex = (currentIndex + 1) % speedOptions.length;
        const newRate = speedOptions[nextIndex];
        videoRef.current.playbackRate = newRate;
        setPlaybackRate(newRate);
    };

    const handleProgress = () => {
        setCurrentTime(videoRef.current.currentTime);
    };

    const handleSeek = (event) => {
        const time = (event.target.value / 100) * duration;
        videoRef.current.currentTime = time;
        setCurrentTime(time);
    };

    const handleLoadedMetadata = () => {
        setDuration(videoRef.current.duration);
    };
    const handleFullScreen = () => {
        setFullScreen(true);
        if (containerRef.current.requestFullscreen) {
            containerRef.current.requestFullscreen();
        } else if (containerRef.current.webkitRequestFullscreen) {
            // Safari
            containerRef.current.webkitRequestFullscreen();
        } else if (containerRef.current.msRequestFullscreen) {
            // IE/Edge
            containerRef.current.msRequestFullscreen();
        }
    };
    const handleExitFullScreen = () => {
        setFullScreen(false);
        if (document.exitFullscreen) {
            document.exitFullscreen();
        } else if (document.webkitExitFullscreen) {
            // Safari
            document.webkitExitFullscreen();
        } else if (document.msExitFullscreen) {
            // IE/Edge
            document.msExitFullscreen();
        }
    };
    const removeVideoCover = () => {
        if(isEnded){
            handleRestartVideo()
        } else {
            handlePlayPause();
        }
        setHideCover(true);
        
       
    };
    useEffect(() => {
        const handleFullscreenChange = () => {
            if (!document.fullscreenElement) {
                setFullScreen(false);
                console.log("Exited fullscreen");
            }
        };

        document.addEventListener("fullscreenchange", handleFullscreenChange);

        return () => {
            document.removeEventListener(
                "fullscreenchange",
                handleFullscreenChange
            );
        };
    }, []);

    const handleVideoEnd = () =>{
        setEnded(true);
        setHideCover(false);
        

    }
    const handleRestartVideo=()=>{
        
        videoRef.current.currentTime = 0;
        videoRef.current.play();
        setIsPlaying(true);
        setHideCover(true);
    };

    const useDeviceType = () => {
        const [isMobile, setIsMobile] = useState(false);
      
        useEffect(() => {
          if (navigator.userAgentData) {
            navigator.userAgentData.getHighEntropyValues(["platform"])
              .then(data => {
                setIsMobile(navigator.userAgentData.mobile);
              });
          } else {
            // Fallback for older browsers
            const userAgent = navigator.userAgent;
            const mobileRegex =
              /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i;
            setIsMobile(mobileRegex.test(userAgent));
          }
        }, []);
      
        return isMobile;
      };
      const isMobile = useDeviceType();
     console.log('ismobile',isMobile)


    return (
        <div
            ref={containerRef}
            className={`video-container ${isFullScreen?"full-screen":""}  ${hideCover ? "control-visible" : ""}`}
        >
            {!isMobile &&
            <div onClick={removeVideoCover}
                className={`video-cover ${hideCover ? "d-none" : ""}`}
            >
                <div className="big-play-btn">
                    {isEnded ? ( <Icon value={"repeat"} size={"large"} colorClass={"gray-900-svg"}/>):
                    ( <Icon value={"play-solid"} size={"large"} colorClass={"gray-900-svg gray-900-fill-svg"}/>)}
                   
                </div>
              
            </div>
            }
            <div className={`pause-play-btn  ${isPlaying ? "pause" : "play"}`}>
                {isPlaying ? (
                    <Icon
                        value={"play-solid"}
                        size={"large"}
                        colorClass={"gray-900-svg gray-900-fill-svg"}
                    />
                ) : (
                    <Icon
                        value={"pause-solid"}
                        size={"large"}
                        colorClass={"gray-900-svg gray-900-fill-svg"}
                    />
                )}
            </div>

            <video
                ref={videoRef}
                onTimeUpdate={handleProgress}
                onLoadedMetadata={handleLoadedMetadata}
                onEnded={handleVideoEnd}
                style={{ width, height }}
                src={src}
                controls={isMobile} // Disable default controls
                onClick={removeVideoCover}
            ></video>
            {!isMobile &&(
            <div className="video-controls-container">
                <div className="video-progress-container">
                    <input
                        type="range"
                        min="0"
                        max="100"
                        value={(currentTime / duration) * 100 || 0}
                        onChange={handleSeek}
                        style={{ flex: 1 }}
                    />
                </div>
                <div className="control-btns">
                    <div className="d-flex">
                        <div className="d-flex border-right-1">
                            <button
                                className="vdo-play-btn"
                                onClick={handlePlayPause}
                            >
                                {isPlaying ? (
                                    <Icon
                                        value={"pause-solid"}
                                        size={"medium"}
                                        colorClass={"gray-50-svg"}
                                    />
                                ) : (
                                    <Icon
                                        value={"play-solid"}
                                        size={"medium"}
                                        colorClass={"gray-50-svg"}
                                    />
                                )}
                            </button>
                            <button
                                className="vdo-back-btn"
                                onClick={handleBackward}
                            >
                                <Icon
                                    value={"-5"}
                                    size={"medium"}
                                    colorClass={"gray-50-svg"}
                                />
                            </button>
                            <button
                                className="vdo-fwd-btn"
                                onClick={handleForward}
                            >
                                <Icon
                                    value={"+5"}
                                    size={"medium"}
                                    colorClass={"gray-50-svg"}
                                />
                            </button>
                        </div>
                        <div className="d-flex border-right-1 align-items-center">
                            <span 
                                className={`vdo-speed btn ${
                                    playbackRate !== 1 ? "active-speed" : ""
                                }`}
                                onClick={toggleSpeed}
                            >
                                {playbackRate}x
                            </span>
                            <span className="vdo-duration">
                                <span className="vdo-time-current">
                                {Math.floor(currentTime / 60)}:
                                {Math.floor(currentTime % 60)
                                    .toString()
                                    .padStart(2, "0")}{" "}
                                    </span>
                                    <span className="vdo-time-seprator">/</span>
                                    <span className="vdo-time-duration">
                                     {Math.floor(duration / 60)}:
                                {Math.floor(duration % 60)
                                    .toString()
                                    .padStart(2, "0")}
                                    </span>
                            </span>
                        </div>
                    </div>
                    {isFullScreen ? (
                        <div
                            className="d-flex hover-pointer"
                            onClick={handleExitFullScreen}
                        >
                            <Icon
                                value={"minimize-cards"}
                                size={"medium"}
                                cssClasses={"mr-1"}
                                colorClass={"gray-50-svg"}
                            />
                            <Text
                                type={"body-text-3"}
                                fontWeight={"medium-font"}
                                cssClasses={"d-none"}
                            >
                                Minimize
                            </Text>
                        </div>
                    ) : (
                        <div
                            className="d-flex hover-pointer"
                            onClick={handleFullScreen}
                        >
                            <Icon
                                value={"maximize"}
                                size={"medium"}
                                cssClasses={"mr-1"}
                                colorClass={"gray-50-svg"}
                            />
                            <Text
                                type={"body-text-3"}
                                fontWeight={"medium-font"}
                                cssClasses={"d-none"}
                            >
                                Full screen
                            </Text>
                        </div>
                    )}
                </div>
            </div>
            )}
        </div>
    );
};

VideoPlayer.propTypes = {
    src: PropTypes.string.isRequired, // Video source
    width: PropTypes.string, // Width of the video player
    height: PropTypes.string, // Height of the video player
};

export default VideoPlayer;
